export type EntryType =
  | "premiumStoreView"
  | "premiumStoreClick"
  | "premiumBrandView"
  | "premiumBrandClick"
  | "storeView"
  | "storeClick"
  | "brandView"
  | "brandClick"
  | "productView"
  | "productClick"
  | "campaignView"
  | "campaignClick"
  | "searchWordClick"
  | "storeHomepageView"
  | "brandHomepageView"
  | "storeHomepageCampaignView"
  | "storeHomepageCampaignClick"
  | "storeHomepageProductView"
  | "storeHomepageProductClick"
  | "similarProductView"
  | "similarProductClick"
  | "brandHomepageProductView"
  | "brandHomepageProductClick"
  | "shoppingListAdd"
  | "shoppingListRemove"
  | "shoppingListDelete"
  | "productHomepageView"
  | "productHomepageClick"
  | "productHomepageBrandHomepageClick"
  | "productHomepageBrandSearchClick"
  | "searchHomepageProductView"
  | "searchHomepageProductClick"
  | "shoppingListShareClick"
  | "shoppingListSimillarProductClick"
  | "shoppingListBrandClick"
  | "shoppingListItemChecked"
  | "campaignOpen"
  | "campaignPageProductView"
  | "campaignPageProductClick"
  | "campaignPageBrandView"
  | "premiumCampaignView"
  | "premiumCampaignClick"
  | "sharedShoppingListItemChecked"
  | "storeHomepageFavorite"
  | "favoriteHomepageStoreFavorite"
  | "brandHomepageFavorite"
  | "favoriteHomepageBrandFavorite"
  | "homeTutorialView"
  | "homeTutorialNextClick"
  | "homeTutorialCloseClick"
  | "homeTutorialComplete"
  | "leftPromoBarClick"
  | "rightPromoBarClick"
  | "leftPromoBarSignup"
  | "rightPromoBarSignup";

export type LogStatOpts = {
  id?: string;
  idBrand?: string;
  idStore?: string;
  type?: string;

  // Kept so existing calls don't break.
  // These are NOT sent to analytics anymore.
  seoTitle?: string;
  seoDescription?: string;
  linkedBrandId?: string;
  linkedBrandName?: string;
  description?: string;

  storeId?: string;
  storeAlias?: string;
  brandId?: string;
  brandName?: string;
  brandAlias?: string;
  productId?: number;
  productIdPb?: string;
  pageId?: number;
  campaignId?: string;
  checked?: boolean;
  searchWordId?: string;
  status?: boolean;
  deviceType?: "desktop" | "mobile";
  userType?: "user" | "guest";
};

export const logStatEvent = async (
  userId: string | null,
  entryType: EntryType,
  opts: LogStatOpts = {},
): Promise<void> => {
  const isDevEnvironment =
    typeof window !== "undefined" &&
    (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname.includes("dev") ||
      window.location.hostname.includes("staging")
    );

  // Preserve your current behavior:
  // normal analytics aren't recorded from dev/staging,
  // but tutorial analytics are.
  // if (
  //   isDevEnvironment &&
  //   !entryType.startsWith("homeTutorial")
  // ) {
  //   return;
  // }

  // Preserve your current behavior.
  if (!userId) {
    return;
  }

  const {
    id,
    idBrand,
    idStore,
    type,

    storeId,
    storeAlias,

    brandId,
    brandName,
    brandAlias,

    productId,
    productIdPb,

    pageId,
    campaignId,

    checked,
    searchWordId,
    status,

    deviceType,
    userType = "user",
  } = opts;

  try {
  //     console.log("🔥 logStatEvent SENDING", {
  //   userId,
  //   entryType,
  //   opts,
  // });

const statsEndpoint =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
    ? "https://vsichkibroshuri.com/worker-api/stats"
    : "/worker-api/stats";

const response = await fetch(statsEndpoint, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        userId,
        entryType,

        id,
        idBrand,
        idStore,
        type,

        storeId,
        storeAlias,

        brandId,
        brandName,
        brandAlias,

        productId,
        productIdPb,

        pageId,
        campaignId,

        checked,
        searchWordId,
        status,

        deviceType,
        userType,
      }),

      // Allows the browser to finish sending small analytics
      // requests during page navigation/unload.
      keepalive: true,
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "");

      console.error(
        "❌ stats logging failed:",
        response.status,
        text,
      );
    }
  } catch (error) {
    // Analytics should NEVER break the actual website.
    console.error("❌ stats logging failed:", error);
  }
};
